import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Template from '../../components/Template';
import i18n from '../../translate/i18n';

import './styles.css';

// SERVICES
import { getProfile } from '../../services/UserService';

// ICONS
import { ReactComponent as BellIcon } from '../../assets/icons/Bell_out.svg';
import { ReactComponent as UserIcon } from '../../assets/icons/User_out.svg';

// COMPONENTS
import GeralConfigComponent from './GeralConfig';
import NotificacoesConfigComponent from './NotificacoesConfig';
import Alert from '../../helpers/Alert';

interface TypeData {
  id: string,
  name: string;
  email: string;
  picture: string;
  branch: string;
  password: string;
}


export default function Config() {
  let history = useNavigate();
  const [data, setData] = useState<TypeData>({ id: '', name: '', picture: '', email: '', branch: '', password: '' });
  const [menuSelected, setMenuSelected] = useState('geral')

  // buscar dados do usuario
  useEffect(() => {
    getProfile().then(res => {
      if (res.data)
        setData(res.data)
    }).catch(err => {
      Alert(false, 'Perfil não encontrado!')
      history(-1)
    })
  }, [])

  return (
    <Template path={i18n.t('menu.settings')}>
      <div className='container'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-3'>
              <div className='container-box'>
                <h5>Meu perfil</h5>
                <hr />
                <ul className='menu-container-left'>
                  <li
                    onClick={() => { setMenuSelected('geral') }}
                    className={menuSelected === 'geral' ? 'menu-container-left-selected' : ''}
                  >
                    <BellIcon /> <p>Geral</p>
                  </li>
                  <li
                    onClick={() => { setMenuSelected('notificacoes') }}
                    className={menuSelected === 'notificacoes' ? 'menu-container-left-selected' : ''}
                  >
                    <UserIcon /> <p>Notificações</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-9'>
              {menuSelected === 'geral' && <GeralConfigComponent data={data} setData={setData} />}
              {menuSelected === 'notificacoes' && <NotificacoesConfigComponent />}
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
